import {Routes} from '@angular/router';
import {BaseManagementComponent} from './base.management.component';
import {serviceManagementRoutes} from "./service.management/service.management.routes";
import {goodsManagementRoutes} from "./goods.management/goods.management.routes";
import {goodsDetailImgManagementRoutes} from "./service.management/goods-detail-img-management/goods-detail-img-management.routes";
import {
  goodsDetailPropertyManagementRoutes
} from "./service.management/goods-detail-property-management/goods-detail-property-management.routes";

export const base_management_routes: Routes = [
  {
    path: '',
    component: BaseManagementComponent,
    data: {title: '基本信息系统'},
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./index/index.component').then(m => m.IndexComponent),
        data: {title: '首页'},
      },
      {
        path: 'userAccountManagement',
        loadComponent: () => import('./user-account-management/user-account-management.component').then(m => m.UserAccountManagementComponent),
        data: {title: '管理员用户'},
      },
      {
        path: 'systemResourcesAuthorization/:accountId',
        loadComponent: () => import('./system-resources-authorization/system-resources-authorization.component').then(m => m.SystemResourcesAuthorizationComponent),
        data: {title: '系统资源授权'},
      },

      {
        path: 'logisticsManagement',
        loadComponent: () => import('./logistics-management/logistics-management.component').then(m => m.LogisticsManagementComponent),
        data: {title: '物流管理'},
      },
      {
        path: 'expressManagement',
        loadComponent: () => import('./express-management/express-management.component').then(m => m.ExpressManagementComponent),
        data: {title: '快递管理'},
      },
      {
        path: 'distanceManagement',
        loadComponent: () => import('./distance-management/distance-management.component').then(m => m.DistanceManagementComponent),
        data: {title: '配送上门管理'},
      },
      ...goodsManagementRoutes,
      ...serviceManagementRoutes
    ]
  },
];
